export const getApplicationStatus = (payload) => {
    return {status:"Pending"}
}

export const getMessages = (payload) => {
    return { messages: ["message1", "message2"] };
}